'use client';

import { useMemo } from 'react';

import { WallType } from '@app-types/config';
import { ProductParentFull } from '@app-types/product';
import { SalesWallType } from '@app-types/sales';

import { Breadcrumb as BreadcrumbComponent, BreadcrumbElement } from '@components/breadcrumb';

import { paths } from '@helpers/path';

type BreadcrumbProps = {
    type: WallType;
    product: ProductParentFull;
    isRenewal: boolean;
};

export function Breadcrumb({ type, product, isRenewal }: Readonly<BreadcrumbProps>) {
    const elements = useMemo(() => {
        const defaultElements: BreadcrumbElement[] = [
            {
                name: 'home',
                label: 'Accueil',
                href: '/',
            },
        ];

        const newElements: BreadcrumbElement[] = [];

        switch (type) {
            case WallType.PHONE:
                newElements.push({
                    name: 'product type',
                    label: 'Téléphone mobile',
                    href: isRenewal ? paths.renewalPhoneWall : paths.phoneWall,
                });
                if (product.manufacturerCode) {
                    newElements.push({
                        name: 'product filter',
                        label: `Téléphone ${product.manufacturer}`,
                        href: paths.phoneFilter(isRenewal, product.manufacturerCode),
                    });
                }
                break;
            case WallType.ACCESSORY:
                newElements.push({
                    name: 'product type',
                    label: 'Accessoires',
                    href: paths.accessoryWall,
                });

                if (product.manufacturerCode) {
                    newElements.push({
                        name: 'product filter',
                        label: `Accessoires ${product.manufacturer}`,
                        href: paths.accessoryFilter(product.manufacturerCode),
                    });
                }
                break;
            case WallType.SALES_PHONE:
            case WallType.SALES_ACCESSORY:
                newElements.push({
                    name: 'product type',
                    label: 'Bons plans',
                    href: paths.sales(type === WallType.SALES_PHONE ? SalesWallType.PHONE : SalesWallType.ACCESSORY),
                });
                break;
            case WallType.HOTSPOT:
                newElements.push({
                    name: 'product type',
                    label: 'Hotspots et Tablettes',
                    href: paths.hotspotWall,
                });
                break;
        }

        newElements.push({
            name: 'product title',
            label: product.title,
        });

        return [...defaultElements, ...newElements];
    }, [product, isRenewal]);

    return <BreadcrumbComponent elements={elements} />;
}
